/* Main super component */

/* CSS Styles */
import '../assets/css/main.css'

/* SASS Styles */
import '../assets/css/main.scss'

/* Main scripts */
import './main-scripts'

/* Components */
import navMobile from '../components/nav-mobile'
import header from '../components/header'
import hero from '../components/hero'

/* Images */
// eslint-disable-next-line no-unused-vars
import Slide1 from '../assets/images/slide-1.jpg'
// eslint-disable-next-line no-unused-vars
import Slide2 from '../assets/images/slide-2.jpg'

const appStart = () => {
  navMobile.init()
  header.init()
  hero.init()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', appStart)
} else {
  appStart()
}
